import SlsClienteTipoPedidoClient from '@/api/Cadastros/Cliente/sls-cliente-tipo-pedido.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSClienteTipoPedidoService {
  constructor() {
    this.client = new SlsClienteTipoPedidoClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os ClienteTipoPedido');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar ClienteTipoPedido');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar ClienteTipoPedido');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar ClienteTipoPedido');
    }
  }

  async destroy(data) {
    try {
      const { data: response } = await this.client.destroy(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar ClienteTipoPedido');
    }
  }
}
